import { createSlice } from "@reduxjs/toolkit";
import Persistor from "../store/Persistor";
const sidebarCollapseSlice = createSlice({
  name: 'collapsed',
  initialState: {
    collapsed: ((Persistor.get('ui.sidebar.collapsed') || 'false') === 'true')
  },
  reducers: {
    toggle: (state, action) => {
      state.collapsed = !state.collapsed;
      Persistor.store('ui.sidebar.collapsed', state.collapsed);
    }
  }
});
export const { toggle } = sidebarCollapseSlice.actions;

export default sidebarCollapseSlice.reducer;

export const selectCollapsed = (state) => {
  return state.ui.sidebar.collapse.collapsed;
}
